/* eslint-disable prefer-template */
import styled, { css } from 'styled-components';

export const breakpoints = {
    xxs: { size: 360, media: '(min-width: 360px)' },
    xs: { size: 480, media: '(min-width: 480px)' },
    sm: { size: 768, media: '(min-width: 768px)' },
    md: { size: 992, media: '(min-width: 992px)' },
    lg: { size: 1200, media: '(min-width: 1200px)' },
    xl: { size: 1400, media: '(min-width: 1400px)' },
};

const generateMediaQueries = (props) => 
  Object.keys(breakpoints)
    .map(key => 
      props[key] && css`
        @media ${breakpoints[key].media} {
          grid-column: span ${props[key]};
        }
      `
    );

export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-row-gap: ${({ spacingRow }) => ((spacingRow || 0) * 8) + 'px'};
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    @media ${breakpoints.md.media} {
      grid-column-gap: ${({ spacingColumn }) => ((spacingColumn || 0) * 8) + 'px'};
    }

    ${({ responsiveStyles }) => css(responsiveStyles)};
`;

export const GridItem = styled.div`
    width: 100%;
    ${({ span }) => span ? 'grid-column: span ' + span + ';' : ''}
 
    ${({ ...props }) => generateMediaQueries(props)};
`;
